import {
    FETCH_ALL_USERS,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_ALL_USERS_FAILED,
    EDIT_USER,
    EDIT_USER_SUCCESS,
    EDIT_USER_FAILED,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILED,
    FETCH_ALL_USERS_STATIC,
    FETCH_ALL_USERS_STATIC_SUCCESS,
    FETCH_ALL_USERS_STATIC_FAILED,
    USER_DELETED,
    FETCH_ALL_DRIVERS,
    FETCH_ALL_DRIVERS_SUCCESS,
    FETCH_ALL_DRIVERS_FAILED,
} from "../store/types";
import { firebase } from "../config/configureFirebase";
import {
    onValue,
    set,
    push,
    update,
    off,
    get,
    remove,
    ref,
    query,
    orderByChild,
    equalTo,
} from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";
import store from "../store/store";

export const fetchUsers = () => (dispatch) => {
    const { usersRef, allLocationsRef, addonRef } = firebase;

    dispatch({
        type: FETCH_ALL_USERS,
        payload: null,
    });
    onValue(usersRef, async (snapshot) => {
        if (snapshot.val()) {
            const locationdata = await get(allLocationsRef);
            const locations = locationdata.val();
            const data = snapshot.val();
            const arr = Object.keys(data)
                .filter((i) => data[i].usertype != "admin")
                .map((i) => {
                    data[i].id = i;
                    data[i].location =
                        locations && locations[i] ? locations[i] : null;
                    return data[i];
                });
            dispatch({
                type: FETCH_ALL_USERS_SUCCESS,
                payload: arr,
            });
        } else {
            dispatch({
                type: FETCH_ALL_USERS_FAILED,
                payload: "No users available.",
            });
        }
    });
};

export const fetchUsersOnce = () => (dispatch) => {
    const { usersRef, allLocationsRef } = firebase;

    dispatch({
        type: FETCH_ALL_USERS_STATIC,
        payload: null,
    });
    onValue(
        usersRef,
        async (snapshot) => {
            if (snapshot.val()) {
                const locationdata = await get(allLocationsRef);
                const locations = locationdata.val();
                const data = snapshot.val();
                const arr = Object.keys(data).map((i) => {
                    data[i].id = i;
                    data[i].location =
                        locations && locations[i] ? locations[i] : null;
                    return data[i];
                });
                dispatch({
                    type: FETCH_ALL_USERS_STATIC_SUCCESS,
                    payload: arr,
                });
            } else {
                dispatch({
                    type: FETCH_ALL_USERS_STATIC_FAILED,
                    payload: "No users available.",
                });
            }
        },
        { onlyOnce: true }
    );
};

export const clearFetchDrivers = () => (dispatch) => {
    const { driversRef, allLocationsRef } = firebase;
    off(driversRef);
    off(allLocationsRef);
};

export const fetchDrivers = (appType) => async (dispatch) => {
    console.log("🚀 fetchDrivers ACTION STARTED - appType:", appType);
    const { driversRef, allLocationsRef, settingsRef, carAddRef } = firebase;

    try {
        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val();
        console.log("🔍 fetchDrivers - settings loaded:", !!settings);

        dispatch({
            type: FETCH_ALL_DRIVERS,
            payload: null,
        });
        console.log("🔍 fetchDrivers - FETCH_ALL_DRIVERS dispatched");

        // First get cars data
        const carsSnapshot = await get(carAddRef);
        let cars = [];
        if (carsSnapshot.val()) {
            cars = Object.values(carsSnapshot.val());
            console.log(
                "fetchDrivers: cars data from Firebase - count:",
                Object.keys(carsSnapshot.val()).length
            );
            console.log(
                "fetchDrivers: processed cars array length:",
                cars.length
            );
        } else {
            console.log("fetchDrivers: no cars data found in Firebase");
        }

        console.log("getdrivers cars count:", cars.length);

        // Then get drivers data
        onValue(
            driversRef,
            (snapshot) => {
                if (snapshot.val()) {
                    onValue(
                        allLocationsRef,
                        (locres) => {
                            const locations = locres.val();
                            const data = snapshot.val();
                            const arr = Object.keys(data || {})
                                .filter((i) => {
                                    const driver = data[i];
                                    if (!driver) return false;

                                    const hasLocation =
                                        locations && locations[i];
                                    const approved = driver.approved == true;
                                    const activeStatus =
                                        driver.driverActiveStatus == true;
                                    const licenseCheck =
                                        (driver.licenseImage &&
                                            settings.license_image_required) ||
                                        !settings.license_image_required;
                                    const termCheck =
                                        (driver.term &&
                                            settings.term_required) ||
                                        !settings.term_required;

                                    const passes =
                                        data &&
                                        approved &&
                                        activeStatus &&
                                        hasLocation &&
                                        licenseCheck &&
                                        termCheck;

                                    console.log(
                                        `===============> <=============== Drivers ${driver.firstName} passes: ${passes}`
                                    );

                                    return passes;
                                })
                                .map((i) => {
                                    try {
                                        console.log(
                                            "fetchDrivers: processing driver",
                                            i,
                                            "with location:",
                                            locations[i]
                                        );
                                        console.log(
                                            "fetchDrivers: looking for cars for driver",
                                            i
                                        );
                                        console.log(
                                            "fetchDrivers: available cars to search:",
                                            cars.map((c) => {
                                                try {
                                                    return {
                                                        id:
                                                            c && c.id
                                                                ? c.id
                                                                : "unknown",
                                                        driver:
                                                            c && c.driver
                                                                ? c.driver
                                                                : "unknown",
                                                        active:
                                                            c &&
                                                            typeof c.active !==
                                                                "undefined"
                                                                ? c.active
                                                                : false,
                                                        enabled:
                                                            c &&
                                                            typeof c.enabled !==
                                                                "undefined"
                                                                ? c.enabled
                                                                : false,
                                                        hasCars:
                                                            c &&
                                                            c.cars &&
                                                            Array.isArray(
                                                                c.cars
                                                            )
                                                                ? c.cars.length
                                                                : 0,
                                                    };
                                                } catch (error) {
                                                    console.error(
                                                        "Error processing car object:",
                                                        error
                                                    );
                                                    return {
                                                        id: "error",
                                                        driver: "error",
                                                        active: false,
                                                        enabled: false,
                                                        hasCars: 0,
                                                    };
                                                }
                                            })
                                        );

                                        // Filter cars for the current driver
                                        const driverCars = cars.filter(
                                            (car) => {
                                                const carDriver =
                                                    car && car.driver
                                                        ? car.driver
                                                        : null;
                                                const carActive =
                                                    car &&
                                                    typeof car.active !==
                                                        "undefined"
                                                        ? car.active
                                                        : false;
                                                return (
                                                    carDriver === i && carActive
                                                );
                                            }
                                        );

                                        console.log(
                                            `🔍 Found ${driverCars.length} cars for driver ${i}`
                                        );

                                        // Check if this driver has any valid cars with category "cab" and subscription enabled
                                        let hasValidCars = false;
                                        if (
                                            data[i].subscriptionStatus &&
                                            data[i].subscriptionStatus ===
                                                "active"
                                        ) {
                                            hasValidCars = driverCars.some(
                                                (car) => {
                                                    if (
                                                        !car ||
                                                        !car.cars ||
                                                        !Array.isArray(car.cars)
                                                    ) {
                                                        return false;
                                                    }
                                                    return car.cars.some(
                                                        (carDetail) => {
                                                            if (
                                                                !carDetail ||
                                                                !carDetail.category
                                                            ) {
                                                                return false;
                                                            }
                                                            return (
                                                                carDetail.category.includes(
                                                                    "cab"
                                                                ) &&
                                                                carDetail.active ===
                                                                    true
                                                            );
                                                        }
                                                    );
                                                }
                                            );
                                        }

                                        // if (
                                        //     data[i].subscriptionStatus !==
                                        //         "active" ||
                                        //     (!hasValidCars &&
                                        //         subscriptionRequiredData)
                                        // ) {
                                        //     console.log(
                                        //         `fetchDrivers: driver ${i} excluded - subscription: ${data[i].subscriptionStatus}, hasValidCars: ${hasValidCars}`
                                        //     );
                                        //     return null;
                                        // }

                                        let activeCars = [];
                                        console.log(
                                            `🔍 Processing ${cars.length} car entries for driver ${i}`
                                        );
                                        // Process all car entries for this driver
                                        for (let carEntry of driverCars) {
                                            if (
                                                carEntry.cars &&
                                                Array.isArray(carEntry.cars)
                                            ) {
                                                // Multi-service: process cars array
                                                for (
                                                    let n = 0;
                                                    n < carEntry.cars.length;
                                                    n++
                                                ) {
                                                    const element =
                                                        carEntry.cars[n];
                                                    if (
                                                        element.active &&
                                                        element.approved
                                                    ) {
                                                        activeCars.push(
                                                            element
                                                        );
                                                    }
                                                }
                                            } else if (
                                                carEntry.active &&
                                                carEntry.approved
                                            ) {
                                                // Single car entry: treat as single active car
                                                activeCars.push({
                                                    carType: carEntry.carType,
                                                    active: carEntry.active,
                                                    approved: carEntry.approved,
                                                    vehicleNumber:
                                                        carEntry.vehicleNumber,
                                                    vehicleMake:
                                                        carEntry.vehicleMake,
                                                    vehicleModel:
                                                        carEntry.vehicleModel,
                                                    car_image:
                                                        carEntry.car_image,
                                                });
                                            }
                                        }

                                        console.log(
                                            `🔍 Driver ${i} processed: ${activeCars.length} active cars found`
                                        );

                                        return {
                                            id: i,
                                            cars: activeCars,
                                            location:
                                                locations && locations[i]
                                                    ? locations[i]
                                                    : null,
                                            carType: data[i].carType
                                                ? data[i].carType
                                                : null,
                                            vehicleNumber: data[i].vehicleNumber
                                                ? data[i].vehicleNumber
                                                : null,
                                            firstName: data[i].firstName,
                                            lastName: data[i].lastName,
                                            active: data[i].driverActiveStatus,
                                            is_mandatory: data[i].is_mandatory,
                                            // Add missing properties needed for MapScreen filtering
                                            approved: data[i].approved,
                                            driverActiveStatus:
                                                data[i].driverActiveStatus,
                                            queue: data[i].queue,
                                        };
                                    } catch (error) {
                                        console.error(
                                            `❌ Error processing driver ${i}:`,
                                            error
                                        );
                                        return null;
                                    }
                                })
                                .filter((driver) => driver !== null);

                            console.log(
                                "✅ fetchDrivers - SUCCESS! Drivers found:",
                                arr.length
                            );
                            console.log(
                                "🔍 fetchDrivers - first 3 drivers:",
                                arr.slice(0, 3)
                            );

                            dispatch({
                                type: FETCH_ALL_DRIVERS_SUCCESS,
                                payload: arr,
                            });
                            console.log(
                                "🔍 fetchDrivers - FETCH_ALL_DRIVERS_SUCCESS dispatched with",
                                arr.length,
                                "drivers"
                            );
                        },
                        appType === "app" ? { onlyOnce: true } : null
                    );
                } else {
                    console.log(
                        "❌ fetchDrivers - No users available in snapshot"
                    );
                    dispatch({
                        type: FETCH_ALL_DRIVERS_FAILED,
                        payload: "No users available.",
                    });
                }
            },
            appType === "app" ? { onlyOnce: true } : null
        );
    } catch (error) {
        console.error("❌ fetchDrivers ACTION ERROR:", error);
        dispatch({
            type: FETCH_ALL_DRIVERS_FAILED,
            payload: error.message || "Error fetching drivers",
        });
    }
};

export const addUser = (userdata) => async (dispatch) => {
    const { usersRef } = firebase;

    dispatch({
        type: EDIT_USER,
        payload: userdata,
    });

    const countries = store.getState().countrylistdata.countries;

    let countryDetail;
    for (let i = 0; i < countries.length; i++) {
        if (countries[i].country === userdata.country) {
            countryDetail = countries[i];
            break;
        }
    }

    (userdata["country"] = countryDetail.country),
        (userdata["country_code"] = countryDetail.country_code),
        (userdata["currency_code"] = countryDetail.currency_code),
        (userdata["swipe_symbol"] = countryDetail.swipe_symbol),
        (userdata["symbol"] = countryDetail.symbol);

    delete userdata.tableData;

    push(usersRef, userdata)
        .then(() => {
            dispatch({
                type: EDIT_USER_SUCCESS,
                payload: null,
            });
        })
        .catch((error) => {
            dispatch({
                type: EDIT_USER_FAILED,
                payload: error,
            });
        });
};

export const editUser = (id, user) => (dispatch) => {
    const { singleUserRef } = firebase;

    dispatch({
        type: EDIT_USER,
        payload: user,
    });
    let editedUser = user;
    delete editedUser.id;
    delete editedUser.tableData;
    set(singleUserRef(id), editedUser);
};

export const updateUserField = (id, fieldData) => (dispatch) => {
    const { singleUserRef } = firebase;

    dispatch({
        type: EDIT_USER,
        payload: fieldData,
    });

    // Use update to only update specific fields
    update(singleUserRef(id), fieldData);
};

export const updateUserCar = (id, data) => (dispatch) => {
    const { singleUserRef } = firebase;

    dispatch({
        type: EDIT_USER,
        payload: data,
    });
    update(singleUserRef(id), data);
};

export const updateLicenseImage =
    (uid, imageBlob, imageType) => async (dispatch) => {
        const {
            singleUserRef,
            driverDocsRef,
            driverDocsRefBack,
            verifyIdImageRef,
        } = firebase;

        let profile = {};
        if (imageType === "licenseImage") {
            await uploadBytesResumable(driverDocsRef(uid), imageBlob);
            let image = await getDownloadURL(driverDocsRef(uid));
            profile.licenseImage = image;
        }
        if (imageType === "licenseImageBack") {
            await uploadBytesResumable(driverDocsRefBack(uid), imageBlob);
            let image1 = await getDownloadURL(driverDocsRefBack(uid));
            profile.licenseImageBack = image1;
        }
        if (imageType === "verifyIdImage") {
            await uploadBytesResumable(verifyIdImageRef(uid), imageBlob);
            let image1 = await getDownloadURL(verifyIdImageRef(uid));
            profile.verifyIdImage = image1;
        }
        update(singleUserRef(uid), profile);
        dispatch({
            type: EDIT_USER,
            payload: uid,
        });
    };

export const deleteUser = (uid) => (dispatch) => {
    const {
        auth,
        walletHistoryRef,
        singleUserRef,
        userNotificationsRef,
        carsRef,
        carEditRef,
        userLocationRef,
        addressEditRef,
        documentUserRef,
        documentUserEditRef,
        adminSupportRef,
    } = firebase;

    dispatch({
        type: DELETE_USER,
        payload: uid,
    });

    if (auth.currentUser.uid === uid) {
        off(singleUserRef(uid));
        off(walletHistoryRef(uid));
        off(userNotificationsRef(uid));
        off(addressEditRef(uid));
        off(userLocationRef(uid));
        off(adminSupportRef(uid));
    }

    onValue(
        singleUserRef(uid),
        (userdata) => {
            const profile = userdata.val();
            const userEmail = profile?.email || null;
            
            // Delete document_users that match user_id
            onValue(
                query(documentUserRef, orderByChild("user_id"), equalTo(uid)),
                (docSnapshot) => {
                    const documents = docSnapshot.val();
                    if (documents) {
                        const docKeys = Object.keys(documents);
                        for (let i = 0; i < docKeys.length; i++) {
                            remove(documentUserEditRef(docKeys[i]));
                        }
                    }
                },
                { onlyOnce: true }
            );

            // Also delete document_users that match user_email (if email exists)
            // This handles edge cases where document might only have email reference
            if (userEmail) {
                get(documentUserRef).then((allDocsSnapshot) => {
                    const allDocuments = allDocsSnapshot.val();
                    if (allDocuments) {
                        const allDocKeys = Object.keys(allDocuments);
                        for (let i = 0; i < allDocKeys.length; i++) {
                            const doc = allDocuments[allDocKeys[i]];
                            // Delete if user_email matches (regardless of user_id to catch all cases)
                            if (doc && doc.user_email === userEmail) {
                                remove(documentUserEditRef(allDocKeys[i]));
                            }
                        }
                    }
                }).catch((error) => {
                    console.error("Error fetching document_users for email cleanup:", error);
                });
            }

            if (profile.usertype === "driver") {
                onValue(carsRef(uid, profile.usertype), (carssnapshot) => {
                    let cars = carssnapshot.val();
                    if (cars) {
                        const arr = Object.keys(cars);
                        for (let i = 0; i < arr.length; i++) {
                            remove(carEditRef(arr[i]));
                        }
                    }
                });
            }
            remove(walletHistoryRef(uid));
            remove(userNotificationsRef(uid));
            remove(addressEditRef(uid));
            remove(userLocationRef(uid));
            remove(adminSupportRef(uid));

            remove(singleUserRef(uid)).then(() => {
                if (auth.currentUser.uid === uid) {
                    signOut(auth);
                    dispatch({
                        type: USER_DELETED,
                        payload: null,
                    });
                } else {
                    remove(singleUserRef(uid))
                        .then(() => {
                            dispatch({
                                type: DELETE_USER_SUCCESS,
                                payload: null,
                            });
                        })
                        .catch((error) => {
                            dispatch({
                                type: DELETE_USER_FAILED,
                                payload: error,
                            });
                        });
                }
            });
        },
        { onlyOnce: true }
    );
};
